import { render, staticRenderFns } from "./ModalStartupFrame.vue?vue&type=template&id=42cd8910&scoped=true&"
import script from "./ModalStartupFrame.vue?vue&type=script&lang=js&"
export * from "./ModalStartupFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModalStartupFrame.vue?vue&type=style&index=0&id=42cd8910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd8910",
  null
  
)

export default component.exports